import { ENDPOINTS } from '../utils/endpoints'
import { postAPIwithoutToken } from '../utils/fetchApi'

export interface LoginPayload {
  user_id: string
  password?: string
}

export interface LoginUser {
  id: number
  userId: string
  name: string
  email: string
  type: string
  role: string
}

export interface LoginResponse {
  status?: string
  message?: string
  data?: {
    token: string
    user: LoginUser
  }
}

export async function loginUser(payload: LoginPayload): Promise<LoginResponse> {
  return postAPIwithoutToken<LoginResponse>(ENDPOINTS.LOGIN, payload)
}
